import clsx from "clsx";
import {
  ComponentPropsWithoutRef,
  ContextType,
  createContext,
  ReactElement,
  useContext,
} from "react";

import { TableContext } from "./Table.tsx";

// eslint-disable-next-line react-refresh/only-export-components
export const TableRowContext = createContext<{
  href?: string;
  target?: string;
  title?: string;
}>({
  href: undefined,
  target: undefined,
  title: undefined,
});

export const TableRow = ({
  className,
  href,
  target,
  title,
  ...props
}: {
  href?: string;
  target?: string;
  title?: string;
} & ComponentPropsWithoutRef<"tr">): ReactElement => {
  const { striped } = useContext(TableContext);

  return (
    <TableRowContext.Provider
      value={{ href, target, title } as ContextType<typeof TableRowContext>}
    >
      <tr
        {...props}
        className={clsx(
          className,
          href &&
            "has-[[data-row-link][data-focus]]:outline has-[[data-row-link][data-focus]]:outline-2 has-[[data-row-link][data-focus]]:-outline-offset-2 has-[[data-row-link][data-focus]]:outline-blue-500 dark:focus-within:bg-white/[2.5%]",
          striped && "even:bg-zinc-950/[2.5%] dark:even:bg-white/[2.5%]",
          href && striped && "hover:bg-zinc-950/5 dark:hover:bg-white/5",
          href &&
            !striped &&
            "hover:bg-zinc-950/[2.5%] dark:hover:bg-white/[2.5%]",
        )}
      />
    </TableRowContext.Provider>
  );
};
